export default __webpack_public_path__ + "static/_banner-bg-26b8570d62ad2a72a445c1e26449a2ea.jpg";